import React, { useEffect } from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { AudioOutlined, CloseCircleFilled, PauseCircleOutlined, SendOutlined } from '@ant-design/icons';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';
import AudioMessage from '../../MessageContent/MessageList/MessageBubble/AudioMessage/AudioMessage';
import { commonIconButtonStyle } from '../../../../Shared/Styles/iconButton';

const FooterVoice = ({
    isRecording,
    pendingVoice,
    recordSeconds,
    waveRef,
    wavePathRef,
    startRecording,
    pauseRecording,
    clearPendingVoice,
    sendPendingVoice,
    formatTime,
    setEmojiOpen,
    hasText,
    ICON_SIZE
}) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    const tt = (key, fallback) => {
        const value = t(key);
        return value === key ? fallback : value;
    };

    // Inject simple equalizer keyframes once for the recording animation
    useEffect(() => {
        try {
            if (typeof document === 'undefined') return;
            if (document.getElementById('mf-eq-style')) return;
            const style = document.createElement('style');
            style.id = 'mf-eq-style';
            style.textContent = `@keyframes mfEqAnim { 0%, 100% { transform: scaleY(0.4); } 50% { transform: scaleY(1); } }`;
            document.head.appendChild(style);
        } catch (e) { }
    }, []);

    if (isRecording) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0' }}>
                    <div ref={waveRef} style={{ width: '100%', height: 28, overflow: 'hidden' }}>
                        <svg viewBox="0 0 600 24" preserveAspectRatio="none" style={{ width: '100%', height: '100%', display: 'block' }}>
                            <path ref={wavePathRef} d="M0 12 L600 12" fill="none" stroke="#1DA1F2" strokeWidth="2" />
                        </svg>
                    </div>
                </div>
                <Tooltip title={tt('stop', 'Stop')}>
                    <Button
                        aria-label={tt('stop', 'Stop')}
                        icon={<PauseCircleOutlined style={{ fontSize: ICON_SIZE, color: '#ff4d4f' }} />}
                        type="text"
                        onClick={pauseRecording}
                        style={{ ...commonIconButtonStyle }}
                    />
                </Tooltip>
                <span style={{ fontSize: 12, color: isDarkMode ? '#fff' : '#595959', minWidth: 44, textAlign: 'right' }}>{formatTime(recordSeconds)}</span>
            </div>
        );
    }

    if (pendingVoice) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, width: '100%' }}>
                <div style={{ flex: 1 }}>
                    <AudioMessage url={pendingVoice.url} sender={'customer'} />
                </div>
                <div style={{ display: 'inline-flex', gap: 8, flexShrink: 0 }}>
                    <Tooltip title={tt('delete', 'Delete')}>
                        <Button
                            aria-label={tt('delete', 'Delete')}
                            icon={<CloseCircleFilled style={{ fontSize: 18, color: '#ff4d4f' }} />}
                            type="text"
                            onClick={() => { clearPendingVoice(); setEmojiOpen(false); }}
                            style={{ ...commonIconButtonStyle }}
                        />
                    </Tooltip>
                    <Tooltip title={tt('send_voice', 'Send voice')}>
                        <Button
                            aria-label={tt('send_voice', 'Send voice')}
                            icon={<SendOutlined />}
                            type="primary"
                            onClick={sendPendingVoice}
                            style={{ minWidth: 36, height: 32, borderRadius: 16 }}
                        />
                    </Tooltip>
                </div>
            </div>
        );
    }

    if (!hasText) {
        return (
            <Tooltip title={tt('record_voice', 'Record voice')}>
                <Button
                    aria-label={tt('record_voice', 'Record voice')}
                    icon={<AudioOutlined style={{ fontSize: ICON_SIZE }} />}
                    type="text"
                    onClick={startRecording}
                    style={{ ...commonIconButtonStyle, color: isDarkMode ? '#d9d9d9' : '#595959' }}
                />
            </Tooltip>
        );
    }

    return null;
};

export default FooterVoice;
